import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useParams, useRouteMatch, Route, Switch, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getNavbarHeight, getViewportDimensions } from '../../../models/Utils';
import {
  setHasVisitedInnovation
} from '../../../store/reducers/mainReducer';

import { ADALandmarks, ADAARIARoles } from '../../../models/ADA';

import CreditsWrapper from '../../BuildingBrighterFutures/subcomponents/CreditsWrapper/CreditsWrapper';

import InnovationNested from '../InnovationNested/InnovationNested';

import TopAnimation from '../subcomponents/TopAnimation/TopAnimation';
import TopicScroller from '../subcomponents/TopicScroller/TopicScroller';
import BottomPopup from '../subcomponents/BottomPopup/BottomPopup';

import PastTopicsScroller from '../subcomponents/PastTopicsScroller/PastTopicsScroller';

import './InnovationMain.scss';

const MAX_FEATURED_TOPICS = 4;

const mobileScreenThreshold = 767; // MUST BE IN SYNC WITH CSS

const InnovationIndex = ({ nestedParamHandler }) => {
  useEffect(() => {
    nestedParamHandler('');
  }, []);

  return null;
}

const InnovationMain = props => {
  const [onMobile, setOnMobile] = useState(false);
  const refScreenWidth = useRef(-1);
  const params = useParams();
  const routeMatch = useRouteMatch();
  const dispatch = useDispatch();
  const [ heightParams, setHeightParams ] = useState({ marginTop: 0, height: 0 });
  const [ widthParams, setWidthParams] = useState({ width: 0 });
  const initialized = useSelector(state => state.data.initialized);
  const cmsData = useSelector(state => state.data.cms.innovation);
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const menuOpened = useSelector(state => state.data.menuOpened);
  let [ada, setADA] = useState("");
  const innovationBlocker = useRef(null);
  const [isTopicSelected, setIsTopicSelected] = useState(false);
  const [isTopicScrollerVisible, setIsTopicScrollerVisible] = useState(false);
  const [mainBubbleSize, setMainBubbleSize] = useState(0);
  const [showPast, setShowPast] = useState(false);
  const [showFeatured, setShowFeatured] = useState(false);
  const [topicToPass, setTopicToPass] = useState(null);
  const [linkForNested, setLinkForNested] = useState(null);
  const [nextTopicLink, setNextTopicLink] = useState(null);
  const [nextTopicTitle, setNextTopicTitle] = useState(null);
  const refLastTopicKey = useRef(null);
  const refTopicAnchors = useRef([]);
  const [redirectTo, setRedirectTo] = useState('');

  const getTopicIndexByKey = (key) => key && cmsData?.Topics ? cmsData.Topics.findIndex(topic => topic.Key === key) : -1;

  useEffect(() => {
    document.title = "The Verizon Story - Innovation Rewind";
    setTimeout(() => {
      dispatch(setHasVisitedInnovation(true));
      setADANonRepeating(cmsData.Introduction.AltText);
    }, 100);
  }, []);

  useEffect(() => {
    if (topicToPass?.Key) {
      const topicIndex = getTopicIndexByKey(topicToPass.Key);
      const rect = refTopicAnchors.current[topicIndex].current.getBoundingClientRect();
      document.body.scrollTo(0, document.body.scrollTop + rect.top - heightParams.marginTop - (onMobile ? (heightParams.height - rect.height) / 2 : 0));
    } else if (refLastTopicKey.current) {
      const topicIndex = getTopicIndexByKey(refLastTopicKey.current);
      const rect = refTopicAnchors.current[topicIndex].current.getBoundingClientRect();
      document.body.scrollTo(0, document.body.scrollTop + rect.top - heightParams.marginTop - (onMobile ? (heightParams.height - rect.height) / 2 : 0));
    } else {
      document.body.scrollTo(0, 0);
    }
    refLastTopicKey.current = topicToPass?.Key || null;
  }, [topicToPass]);

  useEffect(() => {

  }, [ada]);

  const handleResize = () => {
    const marginTop = getNavbarHeight();
    const viewport = getViewportDimensions();
    if (refScreenWidth.current !== viewport.width) {
      setOnMobile(viewport.width <= mobileScreenThreshold);
    }
    setHeightParams({
      marginTop,
      height: viewport.height - marginTop
    });
    setWidthParams({
      width: viewport.width
    });
  };

  useLayoutEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const showTopicScroller = () => {
    setIsTopicScrollerVisible(true);
  };

  const mainBubbleSizeSetter = (size) => {
    setMainBubbleSize(size);
  };

  const handleNestedParam = (param) => {
    if (param === cmsData.PastTopicsPath.Text) {
      setShowPast(true);
      setShowFeatured(false);
      setTopicToPass(null);
      setLinkForNested(null);
      setNextTopicLink(null);
      setNextTopicTitle(null);
      setIsTopicScrollerVisible(false);
      return;
    }

    for (let i = 0; i < cmsData.Topics.length; i++) {
      if (cmsData.Topics[i].Path.Text === param) {
        setShowFeatured(i < MAX_FEATURED_TOPICS);
        setShowPast(i >= MAX_FEATURED_TOPICS);
        setTopicToPass(cmsData.Topics[i]);
        setLinkForNested(i < MAX_FEATURED_TOPICS ? routeMatch.path : `${routeMatch.path}/${cmsData.PastTopicsPath.Text}`);
        setNextTopicLink(
          i + 1 != MAX_FEATURED_TOPICS && i + 1 < cmsData.Topics.length
          ? 
          `${routeMatch.url}/${cmsData.Topics[i + 1].Path.Text}`
          :
          null
        );
        setNextTopicTitle(
          i + 1 != MAX_FEATURED_TOPICS && i + 1 < cmsData.Topics.length
          ? 
          cmsData.Topics[i + 1].Title
          :
          null
        );
        return;
      }
    }

    setShowPast(false);
    setShowFeatured(true);
    setTopicToPass(null);
    setLinkForNested(null);
    setNextTopicLink(null);
    setNextTopicTitle(null);

    setRedirectTo('');
  };

  const handleRedirect = (to) => {
    setIsTopicSelected(true);
    setRedirectTo(to);
  };

  if(!initialized){
    return null;
  }

  function setADANonRepeating(text) {
    if (ada == text) return;
    console.log("[VBN] Set ADA: ", ada)
    setADA(text);
  }

  function onClose(){
    setIsTopicSelected(false);
  }

  return (
    <div className={`innovation-home`} role={ADALandmarks.Main}>
      {/* The div below is a hack for getNavbarHeight() to work */}
      <div className="exhibit-menu-container" style={{ height: 0 }}></div>
      <div style={{ height: `${heightParams.marginTop}px` }}></div>
      {/* <div className="ada-hidden" aria-live="assertive" tabIndex="0" role="group">{ada}</div> */}
      {
        showFeatured
        &&
        <>
          <TopAnimation
            isTopicSelected={isTopicSelected}
            sectionHeight={heightParams.height}
            sectionWidth={widthParams.width}
            introData={cmsData.Introduction}
            mainBubbleSizeSetter={mainBubbleSizeSetter}
            onAnimationEnd={showTopicScroller}
            onMobile={onMobile}
          />
          <TopicScroller
            isTopicSelected={isTopicSelected}
            isVisible={isTopicScrollerVisible}
            sectionWidth={widthParams.width}
            sectionHeight={heightParams.height}
            mainBubbleSize={mainBubbleSize}
            topics={cmsData.Topics.filter((t, i) => i < 4)}
            refTopicAnchors={refTopicAnchors}
            bubbleLabels={cmsData.BubbleLabels}
            redirectHandler={handleRedirect}
            onMobile={onMobile}
          />
          <BottomPopup
            isTopicSelected={isTopicSelected}
            linkTo={`${routeMatch.path}/${cmsData.PastTopicsPath.Text}`}
            linkLabel={cmsData.Introduction.PastTopicsLinkLabel}
            darkMode={false}
          />
        </>
      }
      {
        showPast
        &&
        <div className="innovation-past-topics" style={{
          minHeight: `${heightParams.height}px`
        }}>
          <div className="innovation-pt-title-area">
            <div className="cpvi-grid-container">
              <div className="cpvi-grid-row">
                <div className="cpvi-grid-col w12">
                  <div className="innovation-pt-title-holder">
                    <div
                      className={`innovation-pt-title`}
                      style={{ marginTop: `${ 70 / heightParams.height * 100}%` }}
                    >{cmsData.Introduction.SectionTitle}</div>
                    <div
                      className={`innovation-pt-subtitle`}
                      style={{ marginTop: `${ 20 / heightParams.height * 100}%` }}
                    >{cmsData.Introduction.PastTopicsSubtitle}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <PastTopicsScroller
            topics={cmsData.Topics.filter((t, i) => i >= MAX_FEATURED_TOPICS)}
            topicsIndexOffset={MAX_FEATURED_TOPICS}
            refTopicAnchors={refTopicAnchors}
          />
          <BottomPopup
            linkTo={routeMatch.path}
            linkLabel={cmsData.Introduction.FeaturedTopicsLinkLabel}
            darkMode={true}
          />
        </div>
      }
      <div className="credits-el">
        <CreditsWrapper 
          next=""
          title=""
          subtitle=""
        />
      </div>
      <Switch>
        <Route exact path={routeMatch.path}>
          <InnovationIndex nestedParamHandler={handleNestedParam} />
        </Route>
        <Route path={`${routeMatch.path}/:innovationId`}>
          <InnovationNested
            nestedParamHandler={handleNestedParam}
            topic={topicToPass}
            linkToMain={linkForNested}
            linkToNext={nextTopicLink}
            nextTitle={nextTopicTitle}
            topOffset={heightParams.marginTop}
            bubbleLabels={cmsData.BubbleLabels}
            onMobile={onMobile}
            onClose={onClose}
          />
        </Route>
      </Switch>
      { redirectTo && <Redirect to={redirectTo} /> }
      <div className="innovation-blocker" ref={innovationBlocker}></div>
    </div>
  );
};

export default InnovationMain;